/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAlerts$Csv$Params {}

export function getAlerts$Csv(
   http: HttpClient,
   rootUrl: string,
   params?: GetAlerts$Csv$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<any>> {
   const rb = new RequestBuilder(rootUrl, getAlerts$Csv.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'text', accept: 'text/csv', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<any>;
      })
   );
}

getAlerts$Csv.PATH = '/api/weather/reports';
